import { SoundManager } from '../../config/sound/SoundManager';
import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { Beheaded } from '../../Beheaded';
import { GameData } from '../../server/data/GameData';
import { Presentation } from '../../../core/gameflow/controller/Presentation';
import { SplashController, SplashIndex } from '../../modules/splashScreen/SplashController';
import { BeheadedSound } from '../../sound/BeheadedSound';
import { SoundConfig } from '../../config/sound/SoundConfig';

export class WinCapPresentation extends Presentation {
    private soundPlaying: boolean = false;

    checkForActivation(data: GameData): boolean {
        return data.Win.brokeTheBank;
    }

    setGamedData(data: GameData): void {
        SplashController.instance.setData(SplashIndex.BREAKTHEBANK, data);
    }

    preStart(): void {}

    createPresentation(skip: Function): void {
        skip(false);

        if (Beheaded.counter.timeRemaining) {
            this.timeline.to(this, { duration: Beheaded.counter.timeRemaining });
            return;
        }
        SoundManager.fadeOutAmbient(100, 0);

        if (!this.soundPlaying) {
            Beheaded.soundPlayer.playSound(SoundConfig.CAPWIN_COUNTUP);
            this.soundPlaying = true;
        }

        SlotGame.keypadPlugin.setZeroBetSpinCounter(-1);
        SlotGame.keypadPlugin.setWin(Beheaded.model.data.accumulatedRoundWin);
        this.timeline.add(
            SplashController.instance.play(SplashIndex.BREAKTHEBANK, true, true, () => {
                Beheaded.soundPlayer.playSound(SoundConfig.FS_OUTRO_QUIT);
            })
        );
        this.timeline.add(() => Beheaded.backgroundCharacter.stopAnimsCap(), 4);
        this.PresentationState.setInactive();
    }

    public done(): void {
        Beheaded.collectorBar.setLevel(0);
        this.soundPlaying = false;
    }
}
